import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { FooterComponent } from './layout-components/footer/footer.component';
import { HeaderComponent } from './layout-components/header/header.component';
import { LoaderComponent } from './layout-components/loader/loader.component';
import { PageHeaderComponent } from './layout-components/page-header/page-header.component';
import { SidebarComponent } from './layout-components/sidebar/sidebar.component';
import { TabToTopComponent } from './layout-components/tab-to-top/tab-to-top.component';
import { ContentLayoutComponent } from './layout-components/layout/content-layout/content-layout.component';
import { ErrorLayoutComponent } from './layout-components/layout/error-layout/error-layout.component';

import { SwitcherLayoutComponent } from './layout-components/layout/switcher-layout/switcher-layout.component';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgScrollbar, NgScrollbarModule } from 'ngx-scrollbar';

import { RightSidebarComponent } from './layout-components/right-sidebar/right-sidebar.component';
import { HoverEffectSidebarDirective } from './directives/hover-effect-sidebar.directive';
import { CommonModule } from '@angular/common';
import { FullscreenDirective } from './directives/fullscreen-toggle.directive';
import { ToggleThemeDirective } from './directives/toggle-theme.directive';
import { SidemenuToggleDirective } from './directives/sidemenuToggle';
import { SwitcherComponent } from './layout-components/switcher/switcher.component';
import { HeaderSwitcherComponent } from './layout-components/header-switcher/header-switcher.component';
import { NgxColorsModule } from 'ngx-colors';
import { SearchComponentComponent } from './layout-components/search-component/search-component.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ContentHomeLayoutComponent } from './layout-components/layout/content-home-layout/content-home-layout.component';
import { NavService } from './services/nav.service';
import { LoadingDashComponent } from './loading-dash/loading-dash.component';
import { LanguageSelectorComponent } from './layout-components/language-selector/language-selector.component';
import { CountryInfoComponent } from './layout-components/country-info/country-info.component';
import { LabelPipe } from './pipes/transactionLabel.pipe';
import { FormatCurrencyPipe } from './pipes/formatCurrency.pipe';
import { CurrencySymbolPipe } from './pipes/currencySymbol.pipe';
import { PublicLayoutComponent } from './layout-components/layout/public-layout/public-layout.component';
import { HeaderPublicComponent } from './layout-components/header-public/header-public.component';

@NgModule({
  declarations: [
    FooterComponent,
    HeaderComponent,
    HeaderPublicComponent,
    LoaderComponent,
    PageHeaderComponent,
    SidebarComponent,
    SwitcherLayoutComponent,
    TabToTopComponent,
    ContentLayoutComponent,
    PublicLayoutComponent,
    ErrorLayoutComponent,
    SwitcherComponent,
    RightSidebarComponent,
    FullscreenDirective,
    ToggleThemeDirective,
    HoverEffectSidebarDirective,
    SidemenuToggleDirective,
    HeaderSwitcherComponent,
    SearchComponentComponent,
    ContentHomeLayoutComponent,
    LoadingDashComponent,
    LanguageSelectorComponent,
    CountryInfoComponent,
    LabelPipe,
    CurrencySymbolPipe,
    FormatCurrencyPipe,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    NgScrollbar,
    NgxColorsModule,
    TranslateModule
  ],
  exports: [
    PageHeaderComponent,
    TabToTopComponent,

    ContentLayoutComponent,
    ErrorLayoutComponent,
    LoaderComponent,
    SidebarComponent,

    ToggleThemeDirective,
    SidemenuToggleDirective,
    SwitcherComponent,
    LoadingDashComponent,
    LanguageSelectorComponent,
    CountryInfoComponent,
    TranslateModule,
    LabelPipe,
    CurrencySymbolPipe,
    FormatCurrencyPipe,
  ],

  providers: [NavService],
})
export class SharedModule {}
